import { z } from "zod";

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  VITE_API_BASE_URL: z.string().url(),
  VITE_AVESTATE_ORG_ID: z.string().uuid(),
});

const result = envSchema.safeParse(import.meta.env);
if (!result.success) {
  throw new Error(`Invalid VITE_* env: ${result.error.message}`);
}

export const env = result.data;
export type AppEnv = z.infer<typeof envSchema>;
